export const ADD_INSPIRNAUTE = "ADD_INSPIRNAUTE";
export const GET_SKILLS = "GET_SKILLS";
export const ADD_RECRUTER = "ADD_RECRUTER";
export const GET_DOMAIN_RECRUTER = "GET_DOMAIN_RECRUTER";
export const ENVOIE_CONTACT = "ENVOIE_CONTACT";
export const CHECK_EMAIL = "CHECK_EMAIL";